import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import DynamicForm from '../../../../customformComponent/customForm/DynamicForm';
import backicon from "../../../../../Assets/icons/backIcon.svg"

const CustomerInputs = [
  {
    name: "lead_number",
    label: "Lead NO.",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "customer_name",
    label: "Customer Name",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "contact_number",
    label: "Contact Number",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "customer_type",
    label: "Customer Type",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "customer_visit_type",
    label: "Customer Visit Type",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "visit_date",
    label: "Visit Date and Time",
    type: "date",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "address",
    label: "Address",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "pincode",
    label: "Pin Code",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "city",
    label: "City",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "state",
    label: "State",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "country",
    label: "Country",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  // {
  //     name: "fuel_type",
  //     label: "Fuel Type",
  //     type: "multiselectdropdown",
  //     required: true,
  //     options: [
  //       { label: "DIESEL", value: "DIESEL" },
  //       { label: "PETROL", value: "PETROL" },
  //     ],
  //     gridClass: "col-lg-4",
  //   },
  // {
  //   name: "color",
  //   label: "Color",
  //   type: "text",
  //   required: true,
  //   gridClass: "col-lg-4",
  // },
  // {
  //   name: "price",
  //   label: "Price",
  //   type: "number",
  //   required: true,
  //   gridClass: "col-lg-4",
  // },,
];

const QuotationDetailsInputs = [
    {
      name: "ex_showroom",
      label: "Ex Showroom",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "plate_changes",
      label: "Plate  Changes",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "insaurance",
      label: "Insaurance",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "rto_amout",
      label: "RTO Amount",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "accessory_cost",
      label: "Accessory Cost",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "Discount Type",
      label: "discount_type",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "discount_amount",
      label: "Discount Amount",
      type: "number",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "tax_set",
      label: "Tax Set",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "tax_amount",
      label: "Tax Amount",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "onboard_price",
      label: "On Board Price Round",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "onboard_price_roundOff",
      label: "On Board Price RoundOff",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
    {
      name: "remake",
      label: "Remake",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
    },
  ];

const VehicleInputs = [
  {
    name: "vehicle_type",
    label: "Vehicle Type",
    type: "number",
    required: true,
    gridClass: "col-lg-4",
  },
  {
        name: "fuel_type",
        label: "Fuel Type",
        type: "multiselectdropdown",
        required: true,
        options: [
          { label: "DIESEL", value: "DIESEL" },
          { label: "PETROL", value: "PETROL" },
        ],
        gridClass: "col-lg-4",
      },
  {
    name: "make",
    label: "Make",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "model",
    label: "Model",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "variant",
    label: "Variant",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "color",
    label: "Color",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "single_upload",
    label: "Simgle Image",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "family_image",
    label: "Family Image",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
  {
    name: "remarks",
    label: "Remarks",
    type: "text",
    required: true,
    gridClass: "col-lg-4",
  },
];

const AddCancelOrder = () => {

  const [formData, setFormData] = useState({});


  // Add states for table data 
  const [tableData, setTableData] = useState([]); 

  const navigate = useNavigate();

  const handleFormSubmit = (data) => {
    // Convert multiselectdropdown data to a readable format
    const processedData = {
      ...data,
      fuel_type: data.fuel_type.map(item => item.label).join(', ')
    };
    setTableData(prevData => [...prevData, processedData]);
    console.log("Form Data:", processedData);
    setFormData({})
  };

  return (
    <div>
      <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
            <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" />
        <span className="backbtntitle">Edit Subsidy Reconciliation</span>
      </div>


      <div className="btncontainer mt-3 gap-2">
      <button style={{backgroundColor:"#fff", padding:"10px 20px" , borderRadius:"10px", color:"#7BD755", border:"1px solid #7BD755"}}>
            Upload
        </button>
        <button style={{backgroundColor:"#fff", padding:"10px 20px" , borderRadius:"10px", color:"#7BD755", border:"1px solid #7BD755"}}>
            Back
        </button>
        <button
        onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div>

      </div>
      <div className="form-container">
        {/* <div className="d-flex flex-row justify-content-between" style={{marginBottom:"25px"}}>
            <div>
        <span className="cust-det-title mt-2 mb-2">
          Add
        </span>
            </div>
        </div> */}
        <p style={{fontSize:"20px", color:"grey"}}>Personal Details </p>
        <DynamicForm
        formConfig={CustomerInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
          // formConfig={CustomerInputs}
          // formData={formData}
          // setFormData={setFormData}
          // onSubmit={handleFormSubmit}
        />
        <div>
        <p style={{fontSize:"20px", color:"grey"}}>Vehicle Details </p>
        <DynamicForm
        formConfig={VehicleInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
          // formConfig={CustomerInputs}
          // formData={formData}
          // setFormData={setFormData}
          // onSubmit={handleFormSubmit}
        />
        </div>

        <div>
        <p style={{fontSize:"20px", color:"grey"}}>Quotation Details </p>
        <DynamicForm
        formConfig={QuotationDetailsInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
          // formConfig={CustomerInputs}
          // formData={formData}
          // setFormData={setFormData}
          // onSubmit={handleFormSubmit}
        />
        </div>

      </div>
    </div>
  )
}

export default AddCancelOrder;